import React from 'react';

import { PureComponent } from 'core/components'
import { Row, Col } from 'core/components/Framework7';

import classes from './styles.module.css';

export function StepsTab(props) {
  const { step } = props
  return (
    <div className={classes.steps}>
      <Row>
        <Col with="33"
          className={step == 1 ? classes.stepActive : classes.stepDisable}>
          {'مشخصات ارسال'}
        </Col>
        <Col with="33"
          className={step == 2 ? classes.stepActive : classes.stepDisable}>
          {'نوع پرداخت'}
        </Col>
        <Col with="33"
          className={step == 3 ? classes.stepActive : classes.stepDisable}>
          {'تایید نهایی'}
        </Col>
      </Row>
      {/* <Row>
        <Col with="25"
          className={step == 1 ? classes.stepActive : classes.stepDisable}>
          {'مشخصات ارسال'}
        </Col>
        <Col with="25"
          className={step == 4 ? classes.stepActive : classes.stepDisable}>
          {'زمان ارسال'}
        </Col>
        <Col with="25"
          className={step == 2 ? classes.stepActive : classes.stepDisable}>
          {'نوع پرداخت'}
        </Col>
        <Col with="25"
          className={step == 3 ? classes.stepActive : classes.stepDisable}>
          {'تایید نهایی'}
        </Col>
      </Row> */}
    </div>
  )
}